export default "__VITE_ASSET__DtdnTQe1__"